// Chart Sticky Notes — coloured, per-patient notes saved on the chart.
// Base path /api/ehibridge/notes (proxied). See DEV_GUIDE §b.
import { api } from "@/lib/api";

const BASE = "/api/ehibridge/notes";

export async function listStickyNotes(chartUuid, status) {
  const { data } = await api.get(`${BASE}/chart/${encodeURIComponent(chartUuid)}`, { params: status ? { status } : {} });
  return data; // { notes[], total, active, resolved }
}
export async function createStickyNote(body) {
  // { client_id, chart_id, chart_uuid, patient_name?, note_text, color_tag? }
  const { data } = await api.post(BASE, body);
  return data?.note || data;
}
export async function updateStickyNote(id, body) {
  const { data } = await api.put(`${BASE}/${id}`, body); // { note_text, color_tag? }
  return data?.note || data;
}
export async function setStickyStatus(id, status) {
  const { data } = await api.patch(`${BASE}/${id}/status`, { status });
  return data?.note || data;
}
export async function deleteStickyNote(id) {
  const { data } = await api.delete(`${BASE}/${id}`);
  return data;
}

export const STICKY_COLORS = [
  { tag: "yellow", bg: "#FEF3C7", br: "#FDE68A", ink: "#92650B" },
  { tag: "blue", bg: "#DBEAFE", br: "#BFDBFE", ink: "#1E40AF" },
  { tag: "green", bg: "#DCFCE7", br: "#BBF7D0", ink: "#166534" },
  { tag: "pink", bg: "#FCE7F3", br: "#FBCFE8", ink: "#9D266D" },
  { tag: "orange", bg: "#FFEDD5", br: "#FED7AA", ink: "#9A3412" },
  { tag: "purple", bg: "#EDE9FE", br: "#DDD6FE", ink: "#5B21B6" },
  { tag: "red", bg: "#FEE2E2", br: "#FECACA", ink: "#991B1B" },
];
export const colorOf = (tag) => STICKY_COLORS.find((c) => c.tag === tag) || STICKY_COLORS[0];

export const STICKY_STATUSES = [
  { v: "active", t: "Active" },
  { v: "resolved", t: "Resolved" },
  { v: "handled", t: "Handled" },
  { v: "no_response", t: "No response" },
  { v: "escalated", t: "Escalated" },
];
export const statusLabel = (s) => (STICKY_STATUSES.find((x) => x.v === s) || { t: s }).t;
export const isClosed = (s) => s === "resolved" || s === "handled";
